/**
 * Shallow equality helpers for flat form-value records.
 */
/** Type guard for non-null objects (records). */
export function isRecord(value) {
    return typeof value === "object" && value !== null;
}
/** Shallow key/value equality between two flat form-value records. */
export function shallowEqualRecords(a, b) {
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length)
        return false;
    return aKeys.every(k => Object.is(a[k], b[k]));
}
